export default __webpack_public_path__ + "static/media/user.7ec1e074.svg";